import { TGeoValue } from '../../../packages/JsonQuery';

export const addBuilderToJsonQuery = (geo: TGeoValue[] | null, id: number): TGeoValue[] => {
  if (!geo) {
    return [{ id, type: 'builder' }];
  }

  return geo.concat({ id, type: 'builder' });
};
